const api = {
  GET_LIST_AUDIT_TRAIL_PORTAL_MERCHANT: '/index.php?r=api/v1/system_log/audit-trail/portal-merchant',
};

export default api;
